import { render, staticRenderFns } from "./Prepay.vue?vue&type=template&id=13ccba2e&scoped=true&"
import script from "./Prepay.vue?vue&type=script&lang=js&"
export * from "./Prepay.vue?vue&type=script&lang=js&"
import style0 from "./Prepay.vue?vue&type=style&index=0&id=13ccba2e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ccba2e",
  null
  
)

export default component.exports